import gql from "graphql-tag";

import { ImportFecBase } from "../../../backend/src/common/import/importFecBase";

import axios from "axios";

import IMPORT_FEC from "../graphql/accountingItem/ImportFEC.gql";
import IMPORT_MAPPING_SUGGESTIONS from "../graphql/accountingItem/ImportMappingSuggestions.gql";
import { getVatAAs } from "./vatServices";
import { store } from "../store/store";
export default class ImportFecFront extends ImportFecBase {
    apollo;
    constructor(companyId, apollo, withAccountingItemImport, repair: boolean = false) {
        super(companyId, withAccountingItemImport, repair);
        this.apollo = apollo;
    }

    async getVatAAsQuery() {
        return await getVatAAs(store.state.accountableAccountTable);
    }

    async importEnd(companyId, logs, reconciliations, updateSalesAccounts) {
        if (this.accountingItemImport) {
            const res: any = await this.apollo.query({
                query: gql`
                    query fileUploadSignedURL($companyId: ID!, $uniqueId: String) {
                        fileUploadSignedURL(
                            data: {
                                contentType: "application/json"
                                companyId: $companyId
                                uniqueId: $uniqueId
                                temporary: true
                            }
                        ) {
                            status
                            url
                            key
                        }
                    }
                `,
                fetchPolicy: "network-only",
                variables: {
                    companyId: companyId,
                    uniqueId: this.accountingItemImport.id,
                },
            });

            const data = {
                logs,
                bankAccounts: this.bankAccounts,
                companies: this.companies,
                users: this.users,
                accountingItems: this.accountingItems,
                reconciliations,
                salesAccounts: updateSalesAccounts ? this.salesAccounts : undefined,
                importCarryForward:
                    this.importCarryForward !== null && this.importCarryForward !== undefined
                        ? this.importCarryForward
                        : false,
                newAccountingFirmAccountableAccountMappings:
                    this.getNewAccountingFirmAccountableAccountMappings(),
            };

            await axios.put(res.data.fileUploadSignedURL.url, data, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const result = await this.apollo.mutate({
                mutation: IMPORT_FEC,
                variables: {
                    accountingFirmId: this.accountingFirmId,
                    companyId: companyId,
                    accountingItemImportId: this.accountingItemImport
                        ? this.accountingItemImport.id
                        : "",
                    importCarryForward:
                        this.importCarryForward !== null && this.importCarryForward !== undefined
                            ? this.importCarryForward
                            : false,
                    repair: this.repair,
                    dataFileKey: res.data.fileUploadSignedURL.key,
                },
            });
            return result.data.importFEC;
        } else {
            const result = await this.apollo.mutate({
                mutation: IMPORT_FEC,
                variables: {
                    accountingFirmId: this.accountingFirmId,
                    companyId: companyId,
                    accountingItemImportId: this.accountingItemImport
                        ? this.accountingItemImport.id
                        : "",
                    repair: this.repair,
                    logs,
                    bankAccounts: this.bankAccounts,
                    companies: this.companies,
                    users: this.users,
                    accountingItems: this.accountingItems,
                    reconciliations,
                    salesAccounts: updateSalesAccounts ? this.salesAccounts : undefined,
                    importCarryForward:
                        this.importCarryForward !== null && this.importCarryForward !== undefined
                            ? this.importCarryForward
                            : false,
                    newAccountingFirmAccountableAccountMappings:
                        this.getNewAccountingFirmAccountableAccountMappings(),
                },
            });
            return result.data.importFEC;
        }
    }

    async upsertAccItemImportEnd(data, companyId) {
        if (!this.accountingItemImport || !this.accountingItemImport.id) {
            let zipResult;
            if (this.zipFile) {
                zipResult = await this.apollo.query({
                    query: gql`
                        query fileUploadSignedURL(
                            $name: String!
                            $sha256: String
                            $contentType: String!
                            $companyId: ID!
                        ) {
                            fileUploadSignedURL(
                                data: {
                                    name: $name
                                    sha256: $sha256
                                    contentType: $contentType
                                    companyId: $companyId
                                }
                            ) {
                                status
                                url
                                key
                            }
                        }
                    `,
                    fetchPolicy: "network-only",
                    variables: {
                        name: this.file.name,
                        // sha256: this.file.sha256,
                        contentType: this.file.type,
                        companyId: companyId,
                    },
                });
                await axios.put(zipResult.data.fileUploadSignedURL.url, this.zipFile, {
                    headers: {
                        "Content-Type": this.zipFile.type,
                    },
                });
            }
            const res: any = await this.apollo.query({
                query: gql`
                    query fileUploadSignedURL(
                        $name: String!
                        $sha256: String
                        $contentType: String!
                        $companyId: ID!
                    ) {
                        fileUploadSignedURL(
                            data: {
                                name: $name
                                sha256: $sha256
                                contentType: $contentType
                                companyId: $companyId
                            }
                        ) {
                            status
                            url
                            key
                        }
                    }
                `,
                fetchPolicy: "network-only",
                variables: {
                    name: this.file.name,
                    sha256: this.file.sha256,
                    contentType: this.file.type,
                    companyId: companyId,
                },
            });

            const deconstrucedName = this.file.name.split(".");

            const type = deconstrucedName[deconstrucedName.length - 1].toUpperCase();

            await axios
                .put(res.data.fileUploadSignedURL.url, this.inputData || this.file, {
                    headers: {
                        "Content-Type": this.file.type,
                    },
                })
                .then(async () => {
                    const importType = this.sylae ? "SYLAE" : "STANDARD";

                    const result = await this.apollo.mutate({
                        mutation: gql`
                            mutation createAccountingItemImport(
                                $companyId: ID!
                                $type: AccountingItemImportType
                                $name: String!
                                $data: Json
                                $accountingPeriod: AccountingPeriodCreateOneInput
                                $file: FileCreateOneInput
                                $zipFile: FileCreateOneInput
                            ) {
                                createAccountingItemImport(
                                    data: {
                                        company: { connect: { id: $companyId } }
                                        type: $type
                                        accountingPeriod: $accountingPeriod
                                        name: $name
                                        file: $file
                                        zipFile: $zipFile
                                        data: $data
                                    }
                                ) {
                                    id
                                    data
                                }
                            }
                        `,
                        variables: {
                            companyId: companyId,

                            file: {
                                create: {
                                    key: res.data.fileUploadSignedURL.key,
                                    type: type,
                                    sha256: this.file.sha256,
                                },
                            },
                            zipFile: zipResult
                                ? {
                                      create: {
                                          key: zipResult.data.fileUploadSignedURL.key,
                                          type: "ZIP",
                                      },
                                  }
                                : undefined,
                            type: importType,
                            name: this.importTitle,
                            data: data,
                            $accountingPeriod: this.accountingPeriod
                                ? { connect: { id: this.accountingPeriod.id } }
                                : undefined,
                        },
                    });
                    this.accountingItemImport = {
                        id: result.data.createAccountingItemImport.id,
                        status: "EDITION",
                    };
                    return true;
                })
                .catch((error) => {
                    console.error("FAILURE!!");
                    console.error(error);
                    return false;
                });
        } else {
            await this.apollo.mutate({
                mutation: gql`
                    mutation updateAccountingItemImport(
                        $id: ID!
                        $companyId: ID!
                        $name: String!
                        $data: Json
                        $accountingPeriod: AccountingPeriodUpdateOneInput
                    ) {
                        updateAccountingItemImport(
                            where: { id: $id }
                            data: {
                                company: { connect: { id: $companyId } }
                                accountingPeriod: $accountingPeriod
                                name: $name
                                data: $data
                            }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    id: this.accountingItemImport.id,
                    companyId: companyId,
                    name: this.importTitle,
                    data: data,
                    accountingPeriod: this.accountingPeriod
                        ? { connect: { id: this.accountingPeriod.id } }
                        : undefined,
                },
            });
        }
    }

    async getMappingSuggestions(importId: string = undefined) {
        if (this.companyId) {
            const output: any = await this.apollo.query({
                query: IMPORT_MAPPING_SUGGESTIONS,
                variables: {
                    companyId: this.companyId,
                    importId,
                },
            });
            if (output.data?.importMappingSuggestions?.suggestions) {
                this.mappingSuggestions = JSON.parse(
                    JSON.stringify(output.data.importMappingSuggestions.suggestions),
                );
                // console.log(output.data.importMappingSuggestions.suggestions)
            }
        }
    }
}
